import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Package, ShoppingBag, TrendingUp, Clock } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminHomePage() {
  const [stats, setStats] = useState({ products: 0, orders: 0, revenue: 0, pending: 0 });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/admin/products"), api.get("/admin/orders")])
      .then(([p, o]) => {
        const orders = o.data;
        const paid = orders.filter((x) => x.payment_status === "pago");
        const pending = orders.filter((x) => x.status === "novo").length;
        setStats({
          products: p.data.length,
          orders: orders.length,
          revenue: paid.reduce((s, x) => s + x.total, 0),
          pending,
        });
        setRecent(orders.slice(0, 5));
      });
  }, []);

  const cards = [
    { label: "Produtos", value: stats.products, icon: Package, color: "bg-rose/30" },
    { label: "Encomendas", value: stats.orders, icon: ShoppingBag, color: "bg-mint/40" },
    { label: "Faturação", value: `€${stats.revenue.toFixed(2)}`, icon: TrendingUp, color: "bg-cream-deep" },
    { label: "A preparar", value: stats.pending, icon: Clock, color: "bg-rose/20" },
  ];

  return (
    <div data-testid="admin-home" className="p-10">
      <p className="text-xs uppercase tracking-widest text-rose-accent">Bem-vindo de volta</p>
      <h1 className="font-heading text-5xl text-cocoa-dark mt-2">Painel</h1>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((c) => (
          <div key={c.label} className="bg-cream rounded-2xl p-6 border border-cocoa/10">
            <div className={`w-11 h-11 rounded-full ${c.color} flex items-center justify-center text-cocoa-dark mb-4`}>
              <c.icon className="w-5 h-5" />
            </div>
            <div className="text-xs uppercase tracking-widest text-cocoa-soft">{c.label}</div>
            <div className="font-heading text-4xl text-cocoa-dark mt-2">{c.value}</div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-cream rounded-2xl p-8 border border-cocoa/10">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading text-2xl text-cocoa-dark">Últimas encomendas</h2>
          <Link to="/admin/encomendas" className="text-xs uppercase tracking-widest text-rose-accent hover:underline">Ver todas</Link>
        </div>
        {recent.length === 0 ? (
          <p className="text-cocoa-soft text-sm">Ainda não há encomendas.</p>
        ) : (
          <ul className="divide-y divide-cocoa/10">
            {recent.map((o) => (
              <li key={o.id} className="py-3 flex items-center justify-between text-sm">
                <div>
                  <p className="text-cocoa-dark font-medium">{o.customer_name}</p>
                  <p className="text-xs text-cocoa-soft">{new Date(o.created_at).toLocaleString("pt-PT")}</p>
                </div>
                <span className="text-cocoa-dark">€{o.total.toFixed(2)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
